<template>
    <div>
        <section class="ch-gw-blog-grids" style="padding-top: 3rem;">
            <div class="container m_container gw_product_detailed">
                <div class="row gw_product_detailed_row">
                    <div id="demo" class="carousel slide gw_product_detailed_carousel" data-ride="carousel" data-interval="5000" >

                        <!-- 轮播图片 -->
                        <div class="carousel-inner" style="width: 100%;padding-top: 0.5rem;background-color: rgb(218, 218, 218);" >
                            <div class="carousel-item gw_product_carousel_item" :class="{'active':index == 0}"  v-for="(item,index) in parentDate.productImag">
                                <div class="row" style="width: 98%;margin: 0 auto;">
                                    <div style="width: 100% ">
                                        <div>
                                            <div class="gw_product_carousel_item_img" >
                                                <el-image
                                                style="width: 100%; height: 100%"
                                                :src="item"
                                                fit="fill">
                                                </el-image>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 指示符 -->
                        <div class="gw_product_carousel_zsf" >
                            <div class="zsf" style="width: 100%;height: 10rem;white-space: nowrap;overflow-x: auto;overflow-y: hidden;">
                                <div data-target="#demo" :data-slide-to="index" class="active" v-for="(item,index) in parentDate.productImag" @click="tarColor(index)"  style="display: inline-block;width: 30%;padding-top: 0.3rem;padding-bottom: 0.3rem;padding-left: 0.3rem;padding-right: 0.3rem;">
                                    <div style="width: 100%;height: 8rem;background-size: cover;" :style="{backgroundImage: 'url('+item+')',border: tarColorIndex == index?'3px solid rgba(71, 194, 255, 0.8)':''}">
                                                
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 左右切换按钮 -->
                        <div class="gw_product_carousel_control">
                            <a class="carousel-control-prev" href="#demo" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#demo" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        </div>

                    </div>
                    <div class="gw_product_detailed_introduce" >
                        <div style="width: 93%;margin: 0 auto;display: flex;padding-top: 1rem;padding-bottom: 1rem;align-items: center;border-bottom: 0.1rem solid rgba(0, 0, 0, 0.1);">
                            <div style="width: 100%;text-align: start;">
                                <h2 style="font-size: 1.8rem;">{{ parentDate.productClassification }}</h2>
                            </div>
                        </div>
                        <div style="height: 10%;"></div>
                        <div class="scroll">
                            <div class="gw_scroll_name" >产品简介：</div>
                            <div style="width: 95%;text-indent:2rem;font-size: 1.3rem;color: #0099ff;font-weight: 700;padding-top: 1.5rem;">{{ parentDate.productName }}</div>
                            <div style="width: 95%;text-indent:2rem;font-size: 1rem;line-height: 2rem;font-weight: 500;padding-top: 1.5rem;"  v-html="parentDate.productContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    name: 'detailed',
    props: ['parentDate'],
    data() {
        return {
            msg: '首页',
            tarColorIndex:0,
        }
    },
    mounted() {
        console.log("this.parentDate",this.parentDate)
    },
    methods: {
        tarColor(t){
            this.tarColorIndex = t;
        }
    }
}
</script>
<style  scoped>

   .scroll::-webkit-scrollbar { /*滚动条整体样式*/
        width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
    }
    /*滚动条样式*/
    .scroll::-webkit-scrollbar { /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
    }
 
    .scroll::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px #00a2fffa;
        background: rgba(0,0,0,.075);
    }
 
    .scroll::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px #fafafa;
        border-radius: 0;
        background: #ececec;
    }

    .zsf::-webkit-scrollbar { /*滚动条整体样式*/
        width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
    }
    /*滚动条样式*/
    .zsf::-webkit-scrollbar { /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 8px;
    }
 
    .zsf::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 5px;
        background: rgba(0,0,0,.085);
    }
 
    .zsf::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px #fafafa;
        border-radius: 0;
        background: #ececec;
    }
</style>



// WEBPACK FOOTER //
// src/components/product/detailed.vue